import { CommonButton, CommonLink } from 'components/common/Forms/Button';
import { Loading } from 'components/common/Loading';
import { useCommonTranslation } from 'hooks/i18n/useCommonTranslation';
import { useCallback } from 'react';
import { patientURL } from 'routes/AppRoutes';

import { useSelfCheckIn } from 'hooks/patient/checkIn/useSelfCheckIn';
import {
  FormButtonBar,
  PatientCheckInWrapperStyled,
} from './PatientCheckIn.styled';
import { PatientCheckInLayout } from './PatientCheckInLayout';

export const PatientCheckInNoCodeInput = () => {
  const { t } = useCommonTranslation();
  const { isLoading, checkInWithoutCode } = useSelfCheckIn();

  const onSubmit = useCallback(
    () => checkInWithoutCode(),
    [checkInWithoutCode],
  );

  return (
    <PatientCheckInLayout
      description={{
        html: t('self-checkin-no-code-description'),
        compact: true,
      }}
    >
      {isLoading && <Loading />}
      <PatientCheckInWrapperStyled>
        <FormButtonBar>
          <CommonButton variant="primary" size="large" onClick={onSubmit}>
            {t('self-checkin-submit')}
          </CommonButton>
          <CommonLink variant="secondary" size="large" to={patientURL}>
            {t('back-to-menu')}
          </CommonLink>
        </FormButtonBar>
      </PatientCheckInWrapperStyled>
    </PatientCheckInLayout>
  );
};
